module.exports = __webpack_public_path__ + "img/site_right_arrow.ce4f3107.svg";